export default __webpack_public_path__ + "static/media/HighpassFilterImg.e6c4a4f5.jpg";